import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ShoppingCartService } from '../../services/shoppingcart.service';
import { MenuService } from '../../services/menu.service';
import { trigger, transition } from '@angular/animations';
import { Item } from '../../models/item.model';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  animations: [
    trigger('blockInitialRenderAnimation', [transition(':enter', [])])
  ]
})
export class ItemComponent implements OnInit {

  @Input() item: Item;
  @Input() locale: string;
  @Input() desktop: boolean;
  @Input() readOnly: boolean;
  @Input() expandAll: boolean;
  totalVolume = 0;

  constructor(
    private translate: TranslateService,
    private shoppingCartService: ShoppingCartService,
    private menuService: MenuService,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.totalVolume = 100;
    // this.readOnly
    //   ? this.item.packages.reduce((volume, item) => volume += this.shoppingCartService.has(item) ? item.volume.value : 0, 0)
    //   : this.item.totalVolume;
  }

  hasSelection(item: Item) {
    return item;
  }
  goTo(url: string) {
    this.router.navigate([url], { relativeTo: this.activeRoute });
  }

}
